import { ReactNode } from 'react';
import { Chip, Paper, Stack, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { useIntl } from '../ComponentsContext';

export const TrialLimitedBox = ({
  elevation,
  direction,
  children,
}: {
  direction?: 'row' | 'column';
  elevation?: number;
  children: ReactNode;
}) => {
  const intl = useIntl();

  return (
    <Paper
      elevation={elevation}
      sx={{
        borderRadius: borderRadius('s'),
        p: 2,
      }}
    >
      <Stack
        direction={direction}
        spacing={2}
        alignItems={direction === 'row' ? 'center' : undefined}
      >
        <Chip
          color="warning"
          sx={{
            width: 'fit-content',
          }}
          label={intl.formatMessage({
            id: 'containers.settings.queues.email.trialLimited.upgradeChip.label',
          })}
        />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            a: {
              color: 'inherit',
              textDecorationColor: 'inherit',
            },
          }}
        >
          {children}
        </Typography>
      </Stack>
    </Paper>
  );
};
